import { useEffect } from 'react';

function useDisableScroll() {
  var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  useEffect(function () {
    var originalOverflow = document.body.style.overflow;
    var originalPaddingRight = document.body.style.paddingRight;
    var scrollBarWidth = window.innerWidth - document.body.clientWidth;
    if (enabled) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = "".concat(scrollBarWidth, "px");
    }

    // eslint-disable-next-line consistent-return
    return function () {
      document.body.style.overflow = originalOverflow;
      document.body.style.paddingRight = originalPaddingRight;
    };
  }, [enabled]);
}

export { useDisableScroll as default };
//# sourceMappingURL=useDisableScroll.js.map
